

















import Vue, { PropOptions } from "vue";
import "./scss";
import { Route } from "@gemma/utils";
import { Routing } from "@timesheets/webapp-support";
import { IData } from "./IData";
import { Id, MutationType, Guid } from "@gemma/typescript-types";
import { IProps } from "./IProps";
import { IComputed } from "./IComputed";
import { IMethods } from "./IMethods";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { ITypedEvent } from "@gemma/events";
import { ILabelled } from "./ILabelled";

export default Vue.extend<IData<Id & { label: string }>, IMethods, IComputed, IProps<ILabelled>>({
  name: "Navigation",
  props: {
    backText: {
      type: String,
      required: true,
    },
    backRoute: {
      type: [String, Function],
      required: false,
    },
    forwardRoute: {
      type: [String, Function],
      required: false,
    },
    value: {
      type: Object,
      default: undefined,
    },
    getItems: {
      type: Function,
      required: true,
    } as PropOptions<() => Promise<ILabelled[]>>,
    itemName: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default(): string {
        return "another " + this.itemName;
      },
    },
    displayDropdown: {
      type: Boolean,
      default: false,
    },
  },
  data(): IData<Id & { label: string }> {
    return {
      dropdownVisible: this.displayDropdown,
      items: undefined,
      selected: undefined,
      showDetails: true,
    };
  },
  computed: {
    backRoute_() {
      return typeof this.backRoute === "function" ? this.backRoute(this.selected) : this.backRoute;
    },
  },
  watch: {
    "value.id": {
      handler(newId) {
        if (newId && this.items) {
          const item = this.items.find(x => x.id === newId);
          this.selected = item;
        }
      },
      immediate: true,
    },
    selected(newSelected: ILabelled) {
      if (newSelected && this.forwardRoute) {
        let path = typeof this.forwardRoute === "function" ? this.forwardRoute(newSelected, this.$site.Routes) : this.forwardRoute;
        if (path !== this.$router.currentRoute.path) {
          this.showDetails = false;
          const route = new Route(path);
          Routing.ensureRoleIdOnUrl(route, this.currentRole);
          this.$router.push(route.fullPath).then(() => {
            Vue.nextTick(() => (this.showDetails = true));
          });
        }
      }
    },
  },
  created() {
    this.selected = this.value;
    WebApplicationConstants.listenerEventBuses.system.on(
      "navigation." + MutationType.Changed + ".*",
      (event: ITypedEvent<string, { id: Guid; label: string }, Guid>) => {
        if (this.items) {
          const item = this.items.find(i => i.id === event.data.id);
          if (item) {
            item.label = event.data.label;
          }
        }
      },
      this
    );
  },
  methods: {
    async click() {
      if (!this.items) {
        this.items = await this.getItems();
        this.selected = this.value;
      }

      this.dropdownVisible = true;
    },
    input(event) {
      this.$emit("input", event);
    },
  },
});
